import axios, { AxiosResponse } from 'axios';
import { UpdateRepairLocationInput } from 'modules/Instruments/models';

export default function updateAsync(apiUrl: string) {
  return function api<TResponse>(
    id: string | undefined | null,
    input: UpdateRepairLocationInput | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/repair-location/${id}`,
          method: 'PUT',
          data: input,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
